import React, { FC } from 'react';
import './index.less';

interface NewIconType {
    className?: string;
    isVisible: boolean;
    type?: 'circle' | 'icon' | 'icon-chinese';
}

const NewIcon: FC<NewIconType> = (props) => {
    if (!props.isVisible) {
        return null;
    }

    const getResult = (type: string): React.ReactElement => {
        if (type === 'circle') {
            return <span className="newicon__circle"></span>;
        }

        if (type === 'icon-chinese') {
            return <div className="newicon__chinese">新</div>;
        }

        return <span className="newicon__box" />;
    };
    return <span className={props.className ? props.className : ''}>{getResult(props.type)}</span>;
};

export default NewIcon;
